<template lang="pug">
section.refugio-map-info.map-info(:class="'color_' + removeHashtag(color)")
  article.tabs-refugio-map-info-global
    .map-info-header(:style="getBackgroundColorPropertyStyle(color)")
      h2 Sistema de Gestión de Inundaciones a Corto Plazo
      i.close.material-icons(@click="close($event)") clear
    .map-info-body
      v-tabs(v-model="activeTab" dark icons-and-text :color="color" slider-color="white" @change="onChangeTabsInRefugioPanel")
        v-tab(href="#tab-1")
          div.tab-legend Resumen General
          i.tab-icon.ap-resumen
        v-tab-item(value="tab-1" :lazy="true")
          .tab-content.tab_1(v-if="activeTab === 'tab-1'")
            ResumenGeneral

        v-tab(href="#tab-2")
          div.tab-legend Equipamiento Social y Centros Municipales
          i.tab-icon.ap-institucion-afectada
        v-tab-item(value="tab-2" :lazy="true")
          .tab-content.tab_2(v-if="activeTab === 'tab-2'")
            Instituciones

        v-tab(href="#tab-3")
          div.tab-legend Albergues Temporales y Familias Censadas
          i.tab-icon.ap-Refuge
        v-tab-item(value="tab-3" :lazy="true")
          .tab-content.tab_3(v-if="activeTab === 'tab-3'")
            RefugiosExpandableList

        v-tab(href="#tab-4")
          div.tab-legend Gestión de Recursos
          i.tab-icon.ap-gestion-recursos
        v-tab-item(value="tab-4" :lazy="true")
          .tab-content.tab_4(v-if="activeTab === 'tab-4'")
            GestionRecursos

        v-tab(href="#tab-5" :lazy="true")
          div.tab-legend Gestión Social
          i.tab-icon.ap-gestion-social
        v-tab-item(value="tab-5")
          .tab-content.tab_5(v-if="activeTab === 'tab-5'")
            GestionSocial

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import theme from '@/theme.js'
import mapInfoMixin from '@/mixins/map-info.js'

const TAB2 = 'tab-2'
const TAB3 = 'tab-3'

export default {
  mixins: [ mapInfoMixin ],
  props: {
    color: {
      type: String,
      default: theme.defaultHeaderColor
    }
  },
  components: {
    ResumenGeneral: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab1/ResumenGeneral'),
    Instituciones: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab2/Instituciones'),
    RefugiosExpandableList: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab3/RefugiosExpandableList'),
    GestionRecursos: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab4/GestionRecursos'),
    GestionSocial: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab5/GestionSocial')
  },
  mounted () {
    this.addRulesForTabIndicator()
    if (this.centroMunicipal || this.institucion) {
      this.showInstitucionesTab()
    }
  },
  methods: {
    ...mapActions(['activateControl']),
    close (event) {
      this.$emit('close', event)
    },
    showInstitucionesTab () {
      this.activeTab = TAB2
      this.addRulesForTabIndicator()
    },
    onChangeTabsInRefugioPanel (tab) {
      this.changeRefugioMapInfoTab(tab)
    },
    changeRefugioMapInfoTab (tab) {
      if (tab === TAB2) this.activateControl('instituciones')
      if (tab === TAB3) this.activateControl('refugios')
      this.onChangeTabs(tab)
    }
  },
  computed: {
    ...mapGetters([ 'currentRefugio', 'centroMunicipal', 'institucion' ])
  },
  watch: {
    centroMunicipal (centroMunicipal) {
      if (centroMunicipal) {
        this.showInstitucionesTab()
      }
    },
    currentRefugio (currentRefugio) {
      if (currentRefugio) {
        this.activeTab = 'tab-3'
        this.addRulesForTabIndicator()
      }
    },
    color () {
      this.addRulesForTabIndicator()
    },
    institucion (institucion) {
      if (institucion) {
        this.showInstitucionesTab()
      }
    },
    activeTab (tab) {
      this.changeRefugioMapInfoTab(tab)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/map/map-info-scoped'

.refugio-map-info
  h2
    font-size: $f28px
    line-height: 1.2

// Estilos para fijar cabezera
$v-tabs-height = $f100px

.map-info
  & >>>
    .v-tabs__container--fixed-tabs,
    .v-tabs__container--icons-and-text
      height: $v-tabs-height
    .v-window
      height: "calc(100vmin - %s - %s - %s - %s - %s)" % ($map-info-title-header-height $v-tabs-height $header-height $footer-height $f5px)
      height: "calc(100vh - %s - %s - %s - %s - %s)" % ($map-info-title-header-height $v-tabs-height $header-height $footer-height $f5px)
      @media screen and (max-width: 850px)
        height: "calc(100vmin - %s - %s - %s)" % ($map-info-title-header-height $v-tabs-height $f5px)
        height: "calc(100vh - %s - %s - %s)" % ($map-info-title-header-height $v-tabs-height $f5px)

</style>
